import api from './index'

export default function getAddressFromZipCode(country, zip) {
  return api.get(`/api/countries/${country}/address/${zip}`)
}

export function autocompleAddress(address, params) {
  return api.get(`/api/autocomple/address/${address}`, {
    params: { ...params },
  })
}

export function locateAddress(address) {
  return api.get(`/api/location/address/${address}`)
}
